module.exports = __webpack_public_path__ + "static/media/PDF_64.afbfe8af.pdf";